'use client'

import dynamic from 'next/dynamic'
import { Avatar, Rating, Typography, Card, CardHeader, CardContent } from '@mui/material'

// Types
import type { CommentItemProps } from '@/types/components/molecules/items/comment'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const GoldStarIconAtom = dynamic(() => import('@/components/atoms/icons/gold-star'))

const CommentItemMolecule = (props: CommentItemProps) => {
	// Props
	const { avatar, username, role, ratingvalue, text } = props

	// Variables
	const { t } = useTranslation()

	return (
		<Card variant="outlined" sx={{ bgcolor: '#fafafa', borderRadius: { xs: 2, md: 3 } }}>
			<CardHeader
				avatar={
					<Avatar alt={username} src={avatar}>
						{t(username)}
					</Avatar>
				}
				title={t(username)}
				subheader={t(role)}
				sx={{
					pb: 1.25,
					'& .MuiCardHeader-title': {
						fontWeight: 700,
						fontSize: { xs: 11.5, md: 18 },
						letterSpacing: -0.1
					},
					'& .MuiCardHeader-subheader': {
						fontWeight: 500,
						fontSize: { xs: 7.5, md: 12 },
						letterSpacing: -0.1
					},
					'& .MuiCardHeader-action': { mr: { xs: -1.5, md: 3.7 } }
				}}
				action={
					<Rating
						value={ratingvalue}
						readOnly
						icon={<GoldStarIconAtom />}
						sx={{
							width: 58.3,
							'& .MuiSvgIcon-root': {
								fontSize: { xs: 10, md: 16 },
								color: '#faad14'
							}
						}}
					/>
				}
			/>

			<CardContent sx={{ pt: 1.25 }}>
				<Typography variant="body2" fontSize={{ xs: 9, md: 14 }} lineHeight={1.55} letterSpacing={-0.2} color="text.secondary">
					{t(text)}
				</Typography>
			</CardContent>
		</Card>
	)
}

export default CommentItemMolecule
